<div class="dialog-container">

  <!-- Header -->
  <div class="dialog-header">
    <span class="dialog-title">Editar item de logística</span>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  @if (loading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  @if (item) {
    <mat-tab-group animationDuration="0ms" class="flex-1 overflow-hidden flex flex-col">

      <!-- ══════════════════════════════════════════ TAB: DADOS ══ -->
      <mat-tab label="Dados">
        <div class="tab-content">

          <!-- Info do item -->
          <div class="section-card">
            <span class="section-title">Informações</span>
            <div class="info-grid">
              <div class="info-item">
                <span class="info-label">Item Proposta</span>
                <span class="info-value">{{ item.itemPropostaId || '-' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Serviço</span>
                <span class="info-value">{{ item.servicoDescricao || '-' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Tipo de Serviço</span>
                <span class="info-value">{{ item.tipoServicoDescricao || '-' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Veículo</span>
                <span class="info-value">{{ item.tipoVeiculoDescricao || '-' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Motorista</span>
                <span class="info-value">{{ item.tipoMotoristaDescricao || '-' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Status</span>
                <span class="info-value">{{ item.statusDescricao || '-' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Origem</span>
                <span class="info-value">{{ item.cidadeOrigem || '-' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Destino</span>
                <span class="info-value">{{ item.cidadeDestino || '-' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">PAX</span>
                <span class="info-value">{{ item.quantidadePassageiro ?? '-' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Valor Proposta</span>
                <span class="info-value">R$ {{ formatCurrency(item.valorProposta) }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Valor Compra</span>
                <span class="info-value">R$ {{ formatCurrency(item.valorCompra) }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Valor c/ Taxa</span>
                <span class="info-value">R$ {{ formatCurrency(item.valorComTaxa) }}</span>
              </div>
            </div>
          </div>

          <!-- Execução (só quando aberto a partir da Torre de Monitoramento) -->
          @if (data.execucao) {
            <div class="section-card">
              <span class="section-title">Execução</span>
              <div class="info-grid">
                <div class="info-item">
                  <span class="info-label">Código OS</span>
                  <span class="info-value">{{ data.execucao.codigoOs || '-' }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">Veículo alocado</span>
                  <span class="info-value">
                    @if (data.execucao.veiculo.placa) {
                      {{ data.execucao.veiculo.categoria || '-' }} · {{ data.execucao.veiculo.modelo || '-' }} · {{ data.execucao.veiculo.placa }}
                    } @else {
                      Não alocado
                    }
                  </span>
                </div>
                <div class="info-item">
                  <span class="info-label">Motorista alocado</span>
                  <span class="info-value">
                    @if (data.execucao.motorista) {
                      {{ data.execucao.motorista.nome }} · {{ data.execucao.motorista.telefone | telefone }}
                    } @else {
                      Não alocado
                    }
                  </span>
                </div>
                <div class="info-item">
                  <span class="info-label">Fornecedor</span>
                  <span class="info-value">{{ data.execucao.fornecedor.nome || '-' }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">Idioma</span>
                  <span class="info-value">{{ descricaoIdioma(data.execucao.idioma) }}</span>
                </div>
              </div>
            </div>
          }

          <!-- Formulário editável -->
          <div class="section-card">
            <span class="section-title">Editar trecho</span>
            <div class="form-grid">

              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Tipo de Trecho</mat-label>
                <mat-select [(ngModel)]="editForm.tipoTrechoId" [compareWith]="compareById">
                  <mat-option [value]="null">Selecione</mat-option>
                  @for (st of stretchTypes; track st.id) {
                    <mat-option [value]="st.id">{{ st.descricao }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>KM Previsto</mat-label>
                <input matInput type="number" [(ngModel)]="editForm.kmPrevisto" />
              </mat-form-field>

              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Data Início</mat-label>
                <input matInput type="date" [(ngModel)]="editForm.dataInicio" />
              </mat-form-field>

              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Hora Início</mat-label>
                <input matInput type="time" [(ngModel)]="editForm.horaInicio" />
              </mat-form-field>

              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Data Final</mat-label>
                <input matInput type="date" [(ngModel)]="editForm.dataFinal" />
              </mat-form-field>

              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Hora Final</mat-label>
                <input matInput type="time" [(ngModel)]="editForm.horaFinal" />
              </mat-form-field>

              <mat-form-field appearance="outline" class="input-tg form-full-width">
                <mat-label>Observação</mat-label>
                <textarea matInput [(ngModel)]="editForm.observacao" rows="3"></textarea>
              </mat-form-field>

            </div>

            <div class="flex justify-end gap-2 mt-2">
              <button mat-button class="btn-tg-white" (click)="close()" [disabled]="saving">Cancelar</button>
              <button mat-flat-button class="btn-tg" (click)="save()" [disabled]="saving">
                @if (saving) { Salvando... } @else { Salvar }
              </button>
            </div>
          </div>

          <!-- Passageiros -->
          <div class="section-card">
            <div class="section-header">
              <span class="section-title" style="margin-bottom:0">Passageiros ({{ item.passageiros?.length ?? 0 }})</span>
              <div class="flex gap-2">
                <button mat-stroked-button class="btn-tg-white" (click)="toggleAddPassageiro()" [disabled]="removingAll || !!removingPassageiroId">
                  <mat-icon>person_add</mat-icon>
                  {{ showAddPassageiro ? 'Fechar' : 'Adicionar passageiro' }}
                </button>
                @if (item.passageiros && item.passageiros.length > 0) {
                  <button mat-stroked-button class="btn-tg-cancel" (click)="esvaziarGrupo()" [disabled]="removingAll || !!removingPassageiroId">
                    @if (removingAll) {
                      <mat-spinner diameter="16" style="display:inline-block;margin-right:6px"></mat-spinner>
                    }
                    Esvaziar grupo
                  </button>
                }
              </div>
            </div>

            @if (showAddPassageiro) {
              <div class="section-card" style="margin-bottom:12px;background:#f8fafc;border-color:#e2e8f0">
                <div class="section-header">
                  <span class="section-title" style="margin-bottom:0;font-size:13px">Passageiros disponíveis</span>
                  <button class="btn-icon" (click)="loadDisponiveis()" [matTooltip]="'Recarregar'">
                    <mat-icon>refresh</mat-icon>
                  </button>
                </div>
                @if (loadingDisponiveis) {
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                } @else if (disponiveis.length === 0) {
                  <p class="empty-msg">Nenhum passageiro disponível para este contrato.</p>
                } @else {
                  <div class="passengers-list">
                    @for (p of disponiveis; track (p.id ?? p.passageiroId)) {
                      <div class="passenger-row">
                        <div class="passenger-info">
                          <span class="passenger-name">{{ p.nome || '-' }}</span>
                          <span class="passenger-detail">Doc: {{ p.documento || '-' }}</span>
                        </div>
                        <div class="passenger-flight">
                          @if (p.companhia || p.voo) {
                            <span class="passenger-detail">{{ p.companhia }} {{ p.voo }}</span>
                            <span class="passenger-detail">{{ p.data || '' }} {{ p.hora?.substring(0,5) || '' }}</span>
                          }
                          @if (p.destinoOrigemAero) {
                            <span class="passenger-detail">{{ p.destinoOrigemAero }}</span>
                          }
                        </div>
                        <div class="passenger-actions">
                          @if (addingPassageiroId === (p.id ?? p.passageiroId)) {
                            <mat-spinner diameter="20"></mat-spinner>
                          } @else {
                            <button mat-icon-button class="btn-icon-add-outline" [matTooltip]="'Adicionar ao item'"
                              (click)="adicionarPassageiro(p)"
                              [disabled]="!!addingPassageiroId || removingAll">
                              <mat-icon>person_add</mat-icon>
                            </button>
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            }

            @if (item.passageiros && item.passageiros.length > 0) {
              <div class="passengers-list">
                @for (p of item.passageiros; track p.passageiroId) {
                  <div class="passenger-row">
                    <div class="passenger-info">
                      <span class="passenger-name">{{ p.nome || '-' }}</span>
                      <span class="passenger-detail">Doc: {{ p.documento || '-' }} &nbsp;|&nbsp; {{ p.contato || '-' }}</span>
                    </div>
                    <div class="passenger-flight">
                      @if (p.companhia || p.voo) {
                        <span class="passenger-detail">{{ p.companhia }} {{ p.voo }}</span>
                        <span class="passenger-detail">{{ p.data || '' }} {{ p.hora?.substring(0,5) || '' }}</span>
                      }
                    </div>
                    <div class="passenger-actions">
                      @if (removingPassageiroId === p.passageiroId) {
                        <mat-spinner diameter="20"></mat-spinner>
                      } @else {
                        <button mat-icon-button class="btn-icon-remove-outline" [matTooltip]="'Remover passageiro'" (click)="removerPassageiro(p)" [disabled]="removingAll || !!removingPassageiroId">
                          <mat-icon>person_remove</mat-icon>
                        </button>
                      }
                    </div>
                  </div>
                }
              </div>
            } @else if (!showAddPassageiro) {
              <p class="empty-msg">Nenhum passageiro neste item.</p>
            }
          </div>

        </div>
      </mat-tab>

      <!-- ══════════════════════════════ TAB: SERVIÇOS ADICIONAIS ══ -->
      <mat-tab label="Serviços Adicionais">
        <div class="tab-content">

          <!-- Valor total -->
          @if (valorTotalServicos != null) {
            <div class="valor-total-bar">
              <span>Total serviços adicionais:</span>
              <strong>R$ {{ formatCurrency(valorTotalServicos) }}</strong>
            </div>
          }

          <!-- Formulário de adição -->
          <div class="section-card">
            <span class="section-title">Adicionar serviço</span>
            <div class="form-grid">

              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Serviço (catálogo completo)</mat-label>
                <mat-select [(ngModel)]="servicoForm.servicoAdicionalId" [compareWith]="compareById"
                  (ngModelChange)="onCatalogoSelect($event)">
                  <mat-option [value]="null">Selecione</mat-option>
                  @for (s of catalogoServicos; track s.id) {
                    <mat-option [value]="s.id">{{ s.descricao }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Serviço (cotado na proposta)</mat-label>
                <mat-select [(ngModel)]="servicoForm.servicoAdicionalId" [compareWith]="compareById"
                  (ngModelChange)="onCatalogoCotadoSelect($event)">
                  <mat-option [value]="null">Selecione</mat-option>
                  @for (s of catalogoServicosCotados; track s.id) {
                    <mat-option [value]="s.id">{{ s.descricao }}</mat-option>
                  } @empty {
                    <mat-option [value]="null" disabled>Nenhum cotado nesta proposta</mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Data</mat-label>
                <input matInput type="date" [(ngModel)]="servicoForm.dataServico" />
              </mat-form-field>

              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Quantidade</mat-label>
                <input matInput type="number" [(ngModel)]="servicoForm.quantidade" (ngModelChange)="recalcTotal()" min="1" />
              </mat-form-field>

              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Taxa (%)</mat-label>
                <input matInput type="number" [(ngModel)]="servicoForm.taxa" (ngModelChange)="recalcTotal()" min="0" />
              </mat-form-field>

              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Valor Unitário (R$)</mat-label>
                <input matInput type="number" [(ngModel)]="servicoForm.valorUnitario" readonly />
              </mat-form-field>

              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Valor Total (R$)</mat-label>
                <input matInput type="number" [(ngModel)]="servicoForm.valorTotal" readonly />
              </mat-form-field>

              <mat-form-field appearance="outline" class="input-tg input-tg-full">
                <mat-label>Observação</mat-label>
                <input matInput [(ngModel)]="servicoForm.observacao" />
              </mat-form-field>

            </div>
            <div class="flex justify-end mt-2">
              <button mat-flat-button class="btn-tg" (click)="addServicoAdicional()" [disabled]="addingServico">
                @if (addingServico) { Adicionando... } @else { Adicionar }
              </button>
            </div>
          </div>

          <!-- Lista de serviços -->
          <div class="section-card">
            <div class="section-header">
              <span class="section-title" style="margin-bottom:0">Serviços lançados</span>
              <button class="btn-icon" (click)="loadServicos()" [matTooltip]="'Recarregar'"><mat-icon>refresh</mat-icon></button>
            </div>
            @if (loadingServicos) {
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            } @else if (servicosAdicionais.length === 0) {
              <p class="empty-msg">Nenhum serviço adicional lançado.</p>
            } @else {
              <div class="servicos-list">
                @for (s of servicosAdicionais; track s.id) {
                  <div class="servico-row">
                    <div class="servico-info">
                      <span class="servico-name">{{ s.descricao || '-' }}</span>
                      <span class="servico-detail">{{ s.dataServico || '-' }} &nbsp;|&nbsp; Qtd: {{ s.quantidade }} &nbsp;|&nbsp; Taxa: {{ s.taxa }}%</span>
                      <span class="servico-detail">Unit: R$ {{ formatCurrency(s.valorUnitario) }} &nbsp;|&nbsp; Total: R$ {{ formatCurrency(s.valorTotal) }}</span>
                      @if (s.observacao) {
                        <span class="servico-detail servico-observacao">{{ s.observacao }}</span>
                      }
                    </div>
                    <div>
                      @if (removingServicoId === s.id) {
                        <mat-spinner diameter="20"></mat-spinner>
                      } @else {
                        <button mat-icon-button class="btn-icon-remove-outline" [matTooltip]="'Remover'" (click)="removeServicoAdicional(s)">
                          <mat-icon>delete</mat-icon>
                        </button>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>

        </div>
      </mat-tab>

    </mat-tab-group>
  }

</div>
